var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"st-vue-loader st-spinner stilingue-colors st-spinner-three-bounce st-vue-loader--small"},_vm._l((_vm.maxCircles),function(index){return _c('div',{key:index,class:_vm.getCircleClass(index)})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }